import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StudentRecordSpinnerComponent } from "./components/student-record-spinner/student-record-spinner.component";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { UploadStudentRecordSpinnerComponent } from "./components/upload-student-record-spinner/upload-student-record-spinner.component";
import { EpimsReferenceSpinnerComponent } from "./components/epims-reference-spinner/epims-reference-spinner.component";
import { ListSpinnerComponent } from "./components/list-spinner/list-spinner.component";

@NgModule({
  imports: [CommonModule, NgxSkeletonLoaderModule],
  declarations: [
    StudentRecordSpinnerComponent,
    UploadStudentRecordSpinnerComponent,
    EpimsReferenceSpinnerComponent,
    ListSpinnerComponent,
  ],
  exports: [
    StudentRecordSpinnerComponent,
    UploadStudentRecordSpinnerComponent,
    EpimsReferenceSpinnerComponent,
    ListSpinnerComponent,
  ],
})
export class SpinnersModule {}
